export default __webpack_public_path__ + "static/media/globe-sm.6039c0d3.svg";